var PubSub = /** @class */ (function () {
    function PubSub() {
        this.events = {};
    }
    PubSub.prototype.subscribe = function (eventName, func) {
        this.events[eventName] = this.events[eventName] || [];
        this.events[eventName].push(func);
    };
    PubSub.prototype.unsubscribe = function (eventName, func) {
        if (this.events[eventName]) {
            this.events[eventName] = this.events[eventName].filter(function (f) { return f != func; });
        }
    };
    PubSub.prototype.publish = function (eventName, data) {
        if (this.events[eventName]) {
            this.events[eventName].slice(0).forEach(function (f) { return f(data); });
        }
    };
    return PubSub;
}());
export { PubSub };
